<template>
  <v-container>
    <!-- <v-col cols="12" class="text-center">
        <span style="font-size: 25px"> 🐂 🐄 🐖 🐐 🐑 🐎</span>
      </v-col> -->
    <!-- Título con botón de retroceso -->
    <v-row align="center" justify="space-between">
      <v-col cols="auto">
        <v-btn icon @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="8" sm="auto" class="text-center">
        <div class="text-h5 font-weight-bold">Registro del Lote, Pesos y Venta</div>
        <div class="text-subtitle-2 mt-1">
          Para producción de Reses, Puercos, Búfalos, Cabras, Ovejas y otros
        </div>
      </v-col>
    </v-row>
      Presiona el botón verde para Agregar o modificar un Lote, pesos y ventas de ganado  
    <!-- Botones de acción -->
    <v-row class="mb-4" dense>
     <!--  <v-col v-if="user_can.add" cols="12" sm="auto">
        <v-btn block rounded color="primary" router to="/ru/inventarios">
          <span class="mr-2" style="font-size: 20px">🐖</span>
          1)Registra Animales (Inventario)
        </v-btn>
      </v-col> -->

      <v-col v-if="user_can.add" cols="12" sm="auto">
        <v-btn block color="primary" router to="/ru/pecuario">
          <span class="mr-2" style="font-size: 20px">🐄</span>
          1.Lote de Ceba y Venta
        </v-btn>
      </v-col>
       <v-col v-if="user_can.add" cols="12" sm="auto">
        <v-btn block color="primary" router to="/ru/reportes/productor/produccion-CebaEngorde">
          <span class="mr-2" style="font-size: 20px"> 🐂</span>
          2.Reportes de la Ceba
        </v-btn>
      </v-col>
    </v-row>
  
    <!-- Buscador -->
    <v-row align="center" class="mb-4">
      <v-col cols="9" sm="9">
        <v-text-field
          v-model="identirubro"
          label="Busca Ganado en Lotes de Ceba"
          outlined
          dense
          hide-details
          @keyup.enter="buscarPorCodigo"
        />
      </v-col>
      <v-col cols="3" sm="3" class="text-sm-left text-center">
        <v-btn
          color="primary"
          @click="buscarPorCodigo"
          height="40"
          width="40"
          min-width="40"
          class="rounded-circle"
        >
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <!-- Resultado de búsqueda -->
    <v-row v-if="resultadoBusqueda && resultadoBusqueda.length > 0">
      <v-col cols="12">
        <v-col cols="12">
          <h3>
            Su Código o ID del ganado buscado es:
            <strong>{{ identirubroBuscado }}</strong>
          </h3>
        </v-col>
        <v-list two-line>
          <template v-for="pecuaria in resultadoBusqueda">
            <form-card
              :key="pecuaria.id"
              :top-text="`Finca • ${getNombreDeFinca(pecuaria.id_finca)}`"
              :top-right-text="pecuaria.fecha"
              :middle-text="`Identificador del ganado ${obtenerIdentirubroCorrecto(
                pecuaria
              )}`"
              :bottom-right-text="producerDescription(pecuaria.productor)"
              :sincronized="pecuaria.sincronizado"
              :opaque="pecuaria.hasOutdatedRecords"
              @click="traerRegistroYNavegar(pecuaria)"
            />
          </template>
        </v-list>
      </v-col>
    </v-row>

    <!-- No se encontró resultado -->
    <v-row v-else-if="busquedaRealizada">
      <v-col cols="12">
        <div class="text-body-2 text-center font-italic">
          No se encontró este Ganado en algun Lote de Engorde o Ceba.
        </div>
      </v-col>
    </v-row>

    <!-- Texto de instrucción -->
    <v-row v-if="!presionobuscar" class="mb-4">
      <v-col cols="12">
        <div class="text-subtitle-1 font-weight-medium">
          Ver mis Lotes de Ceba, Registrar Pesos y Ventas
        </div>
        <div class="text-body-2">
          Presione el rectángulo agregar Ventas, tú Inventario por Lote, Pesos o modificarlos.
        </div>
      </v-col>
    </v-row>

    <!-- Si no hay registros -->
    <v-row v-if="Object.keys(pecuarias).length === 0">
      <v-col cols="12">
        <div class="text-body-1 text-center font-italic">
          Aún no tienes ninguna producción pecuaria registrada.
        </div>
      </v-col>
    </v-row>

    <!-- Listado local -->
    <v-row>
      <v-col cols="12">
        <v-list two-line>
          <template v-for="pecuaria in pecuarias">
            <form-card
              :key="pecuaria.id"
              :top-text="`Finca • ${getNombreDeFinca(pecuaria.id_finca)}`"
              :top-right-text="pecuaria.fecha"
              :middle-text="`Lote de Ganado • ${getNombreDeParcela(
                pecuaria.id_parcela
              )}`"
              :bottom-right-text="producerDescription(pecuaria.productor)"
              :sincronized="pecuaria.sincronizado"
              :opaque="pecuaria.hasOutdatedRecords"
              @click="traerRegistroYNavegar(pecuaria)"
            />
          </template>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { producerDescription } from '@/utilidades'

export default {
  name: 'Pecuarios',
  data() {
    return {
      mi_id_productor: '',
      identirubroBuscado: '',
      identirubro: '',
      resultadoBusqueda: [],
      busquedaRealizada: false,
      buscandoRegistro: false,
      presionobuscar: false,
    }
  },
  computed: {
    ...mapState('registros', ['pecuarias']),
    ...mapGetters('registros', [
      'getNombreDeFinca',
      'getNombreDeParcela',
      'productor_actual',
    ]),
    user_can() {
      return this.$store.getters['auth/userCan'](this.$route.path)
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Pecuarias')
    this.mi_id_productor = this.productor_actual
  },
  methods: {
    producerDescription,
    async traerRegistroYNavegar(registro) {
      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getPecuaria', { id: registro.id })
      }
      // Guardar en localStorage el código buscado
      localStorage.setItem('identirubroBuscado', this.identirubro?.trim() || '')
      this.$router.push(`/ru/pecuario/${registro.id}`)
    },
    async buscarPorCodigo() {
      if (!this.identirubro) return
      this.buscandoRegistro = true
      this.resultadoBusqueda = []
      this.busquedaRealizada = false
      this.presionobuscar = true
      try {
        const registro = this.buscarRegistroPorCodigoLocal()
        if (registro) {
          this.resultadoBusqueda = [registro]
          this.busquedaRealizada = true
        } else {
          // Si no está local, buscar en el servidor
          await this.buscarRegistroPorCodigoEnServidor()
          //console.log('Resultado encontrado:', this.resultadoBusqueda)
        }
      } catch (error) {
        this.resultadoBusqueda = null
        this.busquedaRealizada = true
      } finally {
        this.buscandoRegistro = false
      }
    },
    buscarRegistroPorCodigoLocal() {
      const pecuarias = this.$store.state.registros.pecuarias
      return Object.values(pecuarias).find(
        (pecuaria) => pecuaria.identirubro === this.identirubro.trim()
      )
    },

    async buscarRegistroPorCodigoEnServidor() {
      try {
        const response = await this.$store.dispatch(
          'registros/listarPecuarias',
          {
            id_productor: this.mi_id_productor,
            identirubro: this.identirubro.trim(),
          }
        )

        if (
          response &&
          response.status === 'ok' &&
          Array.isArray(response.data) &&
          response.data.length > 0
        ) {
          this.resultadoBusqueda = response.data
        } else {
          this.resultadoBusqueda = []
        }
      } catch (error) {
        //console.error('Error al buscar en el servidor:', error)
        this.resultadoBusqueda = []
      }

      this.busquedaRealizada = true
    },
    obtenerIdentirubroCorrecto(pecuaria) {
      if (!pecuaria.producciones) return 'N/A'
      const encontrado = pecuaria.producciones.find(
        (prod) => prod.identirubro === this.identirubro
      )
      return encontrado ? encontrado.identirubro : 'N/A'
    },
  },
}
</script>
<style>
.tt {
  margin-top: 40px;
  margin-bottom: -20px;
}
.lista {
  margin-top: 20px;
}
</style>
